// Copyright (c) 2025 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
//import { CLIENT_SECRET, EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
// import { EMPTY_ARRAY, EMPTY_OBJECT, EXPIRY_MONTHS, EXPIRY_YEARS } from '../../constants/globalConstants' //, 
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants' //, 


import { prorateList } from '../../redux/actions/paymentActions'
import { MaskedInput, createDefaultMaskGenerator } from 'react-hook-mask'
import { Circles } from 'react-loader-spinner'
import { handlingPermitServiceCriteria, isLoggedIn, isPermissionExist, perkingParkingTime, phoneMasker, restrictInputValues, sortPortalPermissionByKey, validExpiryDate, restrictSpecialChar, handleKeyPressRestrictLeadingTrailingSpace, shouldShowVehicleColumn, employerDetailsSection, requiredTextInput, formatDecimal } from '../../utils/helper'
// AllowededTime
import moment from 'moment'
import { getCardDataList } from '../../redux/actions/cardDetailsAction'
import { getConfigDetails } from '../../services/config'
import useMobileView from '../../Hooks/useMobileView'

const cardnumbermask = createDefaultMaskGenerator('9999 9999 9999 9999')
const expirymask = createDefaultMaskGenerator('99/99')
import { errorMessage } from '../../constants/errorMessage'
import TCAcceptanceSection from '../../Global/TCAcceptanceSection'
import CardConnectTokenizer from '../../components/walletButtons/CardConnectTokenizer'


function Pass(props) {
    const { guidValue, resValue, setPage, idProof, rateList, dispatch, paymentLoader, formData, setFormData,
        formError, partnerDetails, selectedVehicleList, setTotalPrice, verifyPrepay, walletButtonShow,
        setWalletDisable, validator, isCardFormVisible, setCardFormVisible, tokenRef, setCardToken, setIframeErrorMsg } = props
    const [images, setImages] = useState(EMPTY_OBJECT)
    // const [formData, setFormData] = useState()
    const [facility, setFacility] = useState(EMPTY_OBJECT)
    const [prorateResponse, setProrateResponse] = useState(EMPTY_OBJECT)
    const [refractedVehicleList, setRefractedVehicleList] = useState(EMPTY_ARRAY)
    const [card, setCard] = useState()
    const [couponError, setCouponError] = useState('')
    const [coupon, setCoupon] = useState('')
    const [expiry, setExpiry] = useState()
    //const [phone, setPhone] = useState('')
    // const [name, setName] = useState('')
    // const [email, setEmail] = useState('')
    //const [cvv, setCvv] = useState('')
    // const [expiryMonth, setExpiryMonth] = useState('')
    // const [expiryYear, setExpiryYear] = useState('')
    const [couponRemoveButton, setCouponRemoveButton] = useState()
    const [isCouponApplied, setIsCouponApplied] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [cardList, setCardList] = useState(EMPTY_ARRAY)
    const [accessPermissions, setAccessPermissions] = useState('')
    // const [loginData, setLoginData] = useState(EMPTY_OBJECT)
    const [isConsent, setIsConsent] = useState(true)
    const [selectedPermit, setSelectedPermit] = useState(EMPTY_ARRAY)
    const [cardExpiryMessage, setCardExpiryMessage] = useState('')
    const [showTerm, setTermShow] = useState(false)
    const [isDisplayFacility, setIsDisplayFacility] = useState(false) //PIMS-11105
    const [displayVehicle, setDisplayVehicle] = useState(false)
    // to handle the vehicle for menlo
    const allHaveMst_model = localStorage.getItem('allHaveMst_model') ? JSON.parse(localStorage.getItem('allHaveMst_model')) : true
    const [userID, setUserID] = useState('')
    const isMobile = useMobileView()

    // const loaded = useRef(false)
    const searchParams = new URLSearchParams(location.search)
    const hideAutoRenewConsent = isPermissionExist(accessPermissions, 'Hide Auto Renew Consent')

    useEffect(() => {
        const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
        setAccessPermissions(getAccessPermissionData)
    }, [EMPTY_ARRAY, partnerDetails])

    // PIMS-11105
    useEffect(() => {
        if (formData?.permitService?.some(item => item?.display_facility == 1)) {
            setIsDisplayFacility(true)
        } else {
            setIsDisplayFacility(false)
        }
    }, [])


    useEffect(() => {
        if (hideAutoRenewConsent || (Number(formData?.permit_final_amount) <= 0 && isCouponApplied) || formData?.selFaclity?.facility_configuration?.auto_user_consent_off == '1') {
            setIsConsent(false)
            formData['userConsent'] = false
            setFormData({ ...formData })
        } else {
            setIsConsent(true)
            formData['userConsent'] = true
            setFormData({ ...formData })
        }
    }, [EMPTY_ARRAY, formData?.permit_final_amount, hideAutoRenewConsent])


    useEffect(() => {
        // setPhone('')
        localStorage.setItem('name', '')
        localStorage.setItem('email', '')
        localStorage.setItem('phone', '')
        localStorage.setItem('card_date_expiry_month', '')
        localStorage.setItem('card_date_expiry_year', '')

        localStorage.setItem('card_pan', '')
        localStorage.setItem('CardNumberLast4', '')
        localStorage.setItem('expiration_date', '')

        const signupFormData = JSON.parse(localStorage.getItem('userData'))
        const consent = hideAutoRenewConsent ? false : ((signupFormData && signupFormData?.user && signupFormData?.user?.user_consent && signupFormData?.user?.user_consent == '0') ? false : (Number(formData?.permit_final_amount) <= 0 && isCouponApplied) ? false : true)
        setIsConsent(consent)
        let loginuserID = signupFormData?.user?.id ? signupFormData?.user?.id : ''
        setUserID(loginuserID)
        formData['userConsent'] = consent
        setFormData({ ...formData })
        const facility = JSON.parse(localStorage.getItem('facility'))
        const permits = JSON.parse(localStorage.getItem('permits'))
        setSelectedPermit(permits)
        let finalVehicleList = []
        selectedVehicleList?.map((value) => {
            if (value?.license_plate) {
                finalVehicleList.push({
                    'license_plate': value?.license_plate,
                    'make': value?.othermake ? value?.maketext : value?.make,
                    'make_id': value?.make_id,
                    'model_id': value?.model_id,
                    'model': value?.othermodel ? value?.modeltext : value?.model,
                    'color': value?.color,
                    'color_id': value?.color_id,
                    'style': value?.style,
                    'style_id': value?.style_id,
                    'country': value?.country,
                    'state_id': value?.state_id,
                    'state_code': value?.state_code,
                    'vehicle_type': value?.vehicle_type ?? '',
                    'vehcle_type_id': value?.vehicle_type_id ?? '',
                    'vehicle_number': value?.vehicle_number ?? ''
                })
            }
        })
        setRefractedVehicleList(finalVehicleList)
        const signupFormDatas = JSON.parse(localStorage.getItem('userData'))
        let loginuserIDs = signupFormDatas?.user?.id ? signupFormDatas?.user?.id : ''
        const payLoadData = {
            facility_id: facility?.id,
            driving_license: formData?.license_number,
            permit_rate_id: permits?.id ? permits?.id : formData?.permit_rate_id,
            permit_service: formData?.permitService && formData?.permitService.length > 0 ? formData?.permitService : '',
            desired_start_date: formData?.desired_start_date ? moment(formData?.desired_start_date).format('YYYY/MM/DD') : moment().format('YYYY/MM/DD'),
            email: formData.email,
            vehicleList: finalVehicleList,
            user_id: isLoggedIn() ? loginuserIDs : ''
        }

        if (formData?.promocode && formData?.promocode != '') {
            setCoupon(formData?.promocode)
            handleCouponCode(formData?.promocode)
        } else {
            dispatch(prorateList(payLoadData)).then((res) => {
                setIsLoading(false)
                setIsCouponApplied(false)
                if (searchParams?.get('permitID')) {
                    formData['net_parking_amount'] = '0'
                    formData['surcharge_fee'] = '0'
                    formData['tax_fee'] = '0'
                    formData['additional_fee'] = '0'
                    formData['processing_fee'] = '0'
                    formData['is_guest'] = isLoggedIn() ? '0' : '1'
                    formData['permit_rate'] = '0'
                    formData['coupon_applied'] = false
                    formData['permit_final_amount'] = '0'
                    res.data.net_parking_amount = '0'
                    res.data.permit_final_amount = '0'
                    res.data.total_amount = '0'
                    res.data.permit_rate_prorate = '0'
                    res.data.effective_pro_rate = '0'
                    res.data.effective_days = '0'
                    res.data.base_rate = '0'
                    formData['proRateAPIData'] = res?.data
                } else {
                    formData['net_parking_amount'] = res?.data?.net_parking_amount
                    formData['surcharge_fee'] = res?.data?.surcharge_fee
                    formData['tax_fee'] = res?.data?.tax_fee
                    formData['additional_fee'] = res?.data?.additional_fee
                    formData['processing_fee'] = res?.data?.processing_fee
                    formData['is_guest'] = isLoggedIn() ? '0' : '1'
                    formData['permit_rate'] = res?.data?.base_rate
                    formData['coupon_applied'] = false
                    formData['proRateAPIData'] = res?.data
                    formData['permit_final_amount'] = res?.data?.permit_final_amount ? res?.data?.permit_final_amount : formData?.permit_final_amount
                }

                //get final price from backend permit_final_amount
                setFormData({ ...formData })
                setProrateResponse(res?.data)
                if (Number(res?.data?.total_amount) > 0 && !searchParams?.get('permitID')) {
                    setTotalPrice(Number(res?.data?.total_amount))
                } else {
                    setTotalPrice('0')
                }
                // EOS-2427
                if (searchParams?.get('permitID')) {
                    handleCardShowInZeroAmount('0')
                } else {
                    handleCardShowInZeroAmount(formData.permit_final_amount)
                }

            })
        }
        setIsLoading(true)



        if (isLoggedIn()) {
            if (searchParams?.get('permitID')) {
                handleCardShowInZeroAmount('0')
            } else {
                handleCardShowInZeroAmount(formData.permit_final_amount)
            }
            // const facility_id = formData?.facility_id ? formData?.facility_id : partnerDetails?.facilities?.[0]?.id // PIMS-11105
            // const facility_id = partnerDetails?.facilities?.[0]?.id
            dispatch(getCardDataList()).then((res) => {
                if (res?.data) {
                    setCardList(res?.data?.payments)
                    setIsLoading(false)
                    if (res?.data?.payments && res?.data?.payments?.length > 0) {
                        setCardFormVisible(false)
                        let selectedCard = res?.data?.payments?.filter((card) => card?.is_default == '1')
                        if (selectedCard?.length > 0) {
                            localStorage.setItem('CardNumberLast4', selectedCard[0]?.card_last_four ? selectedCard[0]?.card_last_four : '')
                            localStorage.setItem('expiration_date', selectedCard[0]?.expiry ? selectedCard[0]?.expiry : '')
                            localStorage.setItem('card_type', selectedCard[0]?.card_type ? selectedCard[0]?.card_type : '')
                            setFormData({ ...formData, ['payment_profile_id']: selectedCard[0]?.payment_profile_id, ['card_last_four']: selectedCard[0]?.card_last_four, ['expiry']: selectedCard[0]?.expiry })
                        }
                    }
                }
            }).catch(() => {
                setIsLoading(false)
            })
        } else {
            if (searchParams?.get('permitID')) {
                handleCardShowInZeroAmount('0')
            } else {
                handleCardShowInZeroAmount(formData.permit_final_amount)
            }
        }
    }, [EMPTY_ARRAY])

    // const handleInputChange = (e) => {
    // 	const {name, value} = e.target

    // 	if(name == 'card_date_expiry_month'){
    // 		setExpiryMonth(value)
    // 	}
    // 	if(name == 'card_date_expiry_year'){
    // 		setExpiryYear(value)
    // 	}

    // 	localStorage.setItem([name], value.trim())

    // }

    const handleCardChange = (value) => {
        setCard(value?.trim())
        formData['card_pan'] = value?.trim()
        if (value) {
            localStorage.setItem('CardNumberLast4', value?.trim()?.slice(-4))
        }
        setFormData({ ...formData })
    }

    // const handleExpiryChange = (value) => {
    //     setExpiry(value?.trim())
    //     formData['expiration_date'] = value?.trim()
    //     setFormData({...formData})
    // }

    const handleExpiryChange = (value) => {

        let expiryDateCheck = validExpiryDate(value)
        if (value.length == 4 && !expiryDateCheck) {
            // notify('error', 'Please Enter a valid expire date')
            setCardExpiryMessage('Enter a valid expire date')
            // setExpiry('')
            // formData['expiration_date'] = ''
            // setFormData({ ...formData })
        } else {
            setCardExpiryMessage('')
            setExpiry(value?.trim())
            if (expiryDateCheck) {
                localStorage.setItem('expiration_date', value?.trim())
            }
            formData['expiration_date'] = value?.trim()
            setFormData({ ...formData })

        }

    }
    ////////////////////////////////

    //   const handleExpiryChange = (value) => {

    //    if(value.length == 4  && value.substring(0 , 2) < moment(new Date()).format('MM') && value.substring(2) < moment(new Date()).format('YY')){
    //         notify('error', 'Please Enter a valid expire date')
    //         setExpiry('')
    //         formData['expiration_date'] = ''
    //         setFormData({ ...formData })
    //     }else if(value.length == 4 && value.substring(0 , 2) < moment(new Date()).format('MM') && value.substring(2) <= moment(new Date()).format('YY')){
    //         notify('error', 'Please Enter a valid expire date')
    //         setExpiry('')
    //         formData['expiration_date'] = ''
    //         setFormData({ ...formData })
    //     }else if(value.length == 4 && value.substring(2) < moment(new Date()).format('YY')){
    //         notify('error', 'Please Enter a valid expire date')
    //         setExpiry('')
    //         formData['expiration_date'] = ''
    //         setFormData({ ...formData })
    //     }else if(value.length == 4 && value.substring(0 , 2) >12 ){
    //         notify('error', 'Please Enter a valid expire date')
    //         setExpiry('')
    //         formData['expiration_date'] = ''
    //         setFormData({ ...formData })
    //     } else{
    //         setExpiry(value?.trim())
    //         formData['expiration_date'] = value?.trim()
    //         setFormData({ ...formData })
    //     } 
    // }



    const handleCardSelectChange = (e) => {
        const { value } = e.target
        const selectedCard = cardList?.filter((card) => card?.payment_profile_id == value)
        if (selectedCard.length == 1) {
            localStorage.setItem('CardNumberLast4', selectedCard[0]?.card_last_four)
            localStorage.setItem('expiration_date', selectedCard[0].expiry)
            localStorage.setItem('card_type', selectedCard[0].card_type)
        }
        formData.expiry = selectedCard?.[0]?.expiry
        formData.card_last_four = selectedCard?.[0]?.card_last_four
        formData.payment_profile_id = selectedCard?.[0]?.payment_profile_id
        // setFormData({ ...formData, ['payment_profile_id']: selectedCard[0]?.payment_profile_id })
        // if(isLoggedIn()) {
        // setFormData({ ...formData, ['payment_profile_id']: selectedCard?.[0]?.payment_profile_id, ['card_last_four']: selectedCard?.[0]?.card_last_four, ['expiry']: selectedCard?.[0]?.expiry })
        setFormData(formData)
        // } else {
        //     setFormData({ ...formData, ['payment_profile_id']: selectedCard[0]?.payment_profile_id })
        // }

    }

    const showCardForm = () => {
        setCardFormVisible(true)
        setFormData({ ...formData, ['payment_profile_id']: '' })
    }

    const hideCardForm = () => {
        setCardFormVisible(false)
        setFormData({ ...formData, ['payment_profile_id']: '' })
    }

    useEffect(() => {
        setPage('pass')

        const facility = JSON.parse(localStorage.getItem('facility'))
        setFacility(facility)
        if (idProof?.front || idProof?.back) {
            const front = idProof?.front ? URL.createObjectURL(idProof?.front) : ''
            const back = idProof?.back ? URL.createObjectURL(idProof?.back) : ''

            setImages({ ...images, front: front, back: back })
        }

        const selectedPermit = rateList?.filter((item) => item?.id == Number(formData?.permit_type))
        if (selectedPermit?.permit_rate?.length > 0) {
            const selRate = selectedPermit?.permit_rate?.filter((item) => item?.id === formData?.permit_rate_id)
            formData['permit_rate'] = selRate[0]?.rate
            formData['permit_rate_id'] = selRate[0]?.id

            setFormData({ ...formData })
        }

        delete formData.name
        delete formData.card_pan
        delete formData.card_date_expiry_month
        delete formData.card_date_expiry_year
        delete formData.card_card_security_cvx_2
        delete formData.zip_code
        delete formData.expiration_date

        let isPermitPurchase = formData?.selFaclity?.is_permit_purchase_enabled ? formData?.selFaclity?.is_permit_purchase_enabled : ''

        if (formData?.permitService && formData?.permitService?.length > 0) {
            let checkNegotiate = formData?.permitService?.filter((v) => v?.is_purchase == '0')
            if (checkNegotiate?.length > 0) {
                isPermitPurchase = '0'
            }
        }
        formData['isPermitPurchase'] = isPermitPurchase
        setFormData({ ...formData })

    }, [EMPTY_ARRAY])

    const handleInputFieldsData = (e, i, perItem) => {
        const { name, value } = e.target
        if (name == 'permit_rate') {
            formData['permit_rate'] = perItem?.rate
            formData['permit_rate_id'] = perItem?.id
            setFormData({ ...formData })
            setFormData({ ...formData, ['permit_rate']: value })
            const facility = JSON.parse(localStorage.getItem('facility'))
            const proRatePayload = {
                facility_id: facility?.id,
                driving_license: formData?.license_number,
                permit_rate_id: perItem?.id,
                permit_service: formData?.permitService && formData?.permitService.length > 0 ? formData?.permitService : '',
                desired_start_date: formData?.desired_start_date ? moment(formData?.desired_start_date).format('YYYY/MM/DD') : moment().format('YYYY/MM/DD'),
                email: formData.email,
                vehicleList: refractedVehicleList,
                user_id: isLoggedIn() ? userID : ''
            }
            dispatch(prorateList(proRatePayload)).then((res) => {
                setIsCouponApplied(false)
                formData['permit_rate'] = perItem?.rate
                formData['permit_rate_id'] = perItem?.id
                formData['coupon_applied'] = false
                formData['net_parking_amount'] = res?.data?.net_parking_amount
                formData['surcharge_fee'] = res?.data?.surcharge_fee
                formData['tax_fee'] = res?.data?.tax_fee
                formData['additional_fee'] = res?.data?.additional_fee
                formData['processing_fee'] = res?.data?.processing_fee
                formData['proRateAPIData'] = res?.data
                setFormData({ ...formData })
                setProrateResponse(res?.data)
                if (Number(res?.data?.total_amount) > 0) {
                    setTotalPrice(Number(res?.data?.total_amount))
                } else {
                    setTotalPrice('0')
                }
                if (searchParams?.get('permitID')) {
                    handleCardShowInZeroAmount('0')
                } else {
                    handleCardShowInZeroAmount(formData.permit_final_amount)
                }
            })
        } else if (name == 'promocode') {
            setCoupon(value)
        }
        setFormData({ ...formData, [name]: value })

    }

    const handleConsentChange = (e) => {
        const { name, checked } = e.target
        setIsConsent(!isConsent)
        setFormData({ ...formData, [name]: checked })
    }
    const handleCouponRemove = () => {
        setCouponError('')
        setCoupon('')
        setCouponRemoveButton(false)
        const facility = JSON.parse(localStorage.getItem('facility'))
        const permits = JSON.parse(localStorage.getItem('permits'))

        const payLoadData = {
            is_guest: isLoggedIn() ? '0' : '1',
            facility_id: facility?.id,
            driving_license: formData?.license_number,
            // permit_rate_id: permits?.id,
            permit_rate_id: permits?.id ? permits?.id : formData?.permit_rate_id,
            permit_service: formData?.permitService && formData?.permitService.length > 0 ? formData?.permitService : '',
            desired_start_date: formData?.desired_start_date ? moment(formData?.desired_start_date).format('YYYY/MM/DD') : moment().format('YYYY/MM/DD'),
            email: formData.email,
            vehicleList: refractedVehicleList,
            user_id: isLoggedIn() ? userID : ''

        }
        setIsLoading(true)
        dispatch(prorateList(payLoadData)).then((res) => {
            setIsLoading(false)
            setCouponError('')
            setIsCouponApplied(false)
            if (Number(res?.data?.total_amount) > 0 && !searchParams?.get('permitID')) {
                setTotalPrice(Number(res?.data?.total_amount))
            } else {
                setTotalPrice('0')
            }
            if (searchParams?.get('permitID')) {
                formData['permit_rate'] = '0'
                formData['coupon_applied'] = false
                formData['discount_amount'] = null
                formData['permit_final_amount'] = '0'
                formData['promocode'] = ''
                formData['is_guest'] = isLoggedIn() ? '0' : '1'
                formData['net_parking_amount'] = '0'
                formData['surcharge_fee'] = '0'
                formData['tax_fee'] = '0'
                formData['additional_fee'] = '0'
                formData['processing_fee'] = '0'
                res.data.net_parking_amount = '0'
                res.data.permit_final_amount = '0'
                res.data.total_amount = '0'
                res.data.permit_rate_prorate = '0'
                res.data.effective_pro_rate = '0'
                res.data.effective_days = '0'
                res.data.base_rate = '0'
                formData['proRateAPIData'] = res?.data
            } else {
                formData['permit_rate'] = res?.data?.base_rate
                formData['coupon_applied'] = false
                formData['discount_amount'] = null
                formData['permit_final_amount'] = res?.data?.permit_final_amount ? res?.data?.permit_final_amount : formData?.permit_final_amount
                formData['promocode'] = ''
                formData['is_guest'] = isLoggedIn() ? '0' : '1'
                formData['net_parking_amount'] = res?.data?.net_parking_amount
                formData['surcharge_fee'] = res?.data?.surcharge_fee
                formData['tax_fee'] = res?.data?.tax_fee
                formData['additional_fee'] = res?.data?.additional_fee
                formData['processing_fee'] = res?.data?.processing_fee
                formData['proRateAPIData'] = res?.data
            }
            setProrateResponse(res?.data)
            setFormData({ ...formData })
            if (searchParams?.get('permitID')) {
                handleCardShowInZeroAmount('0')
            } else {
                handleCardShowInZeroAmount(formData.permit_final_amount)
            }
        }).catch(() => {
            setIsLoading(false)
            setCouponError('')
            setIsCouponApplied(false)
        })
    }

    useEffect(() => {
        if (prorateResponse?.hide_auto_consent && prorateResponse?.hide_auto_consent == '1') {
            setIsConsent(false)
            formData['userConsent'] = false
            setFormData({ ...formData })
        }
    }, [prorateResponse])

    const handleCouponCode = (promocode = '') => {
        let promocoupon = coupon ? coupon : promocode
        if (promocoupon) {
            setWalletDisable(true)
            setCouponError('')
            setIsLoading(true)
            setIsCouponApplied(true)
            setCoupon(promocoupon)
            const facility = JSON.parse(localStorage.getItem('facility'))
            const permits = JSON.parse(localStorage.getItem('permits'))
            const proRate = {
                is_guest: isLoggedIn() ? '0' : '1',
                facility_id: facility?.id,
                driving_license: formData?.license_number,
                permit_rate_id: permits?.id,
                promocode: promocoupon,
                client_id: getConfigDetails()?.CLIENT_SECRET,
                email: formData?.email,
                phone: formData?.phone,
                license_plate: refractedVehicleList?.[0]?.license_plate,
                vehicleList: refractedVehicleList,
                bookingType: 'permits',
                permit_service: formData?.permitService && formData?.permitService.length > 0 ? formData?.permitService : '',
                desired_start_date: formData?.desired_start_date ? moment(formData?.desired_start_date).format('YYYY/MM/DD') : moment().format('YYYY/MM/DD'),
                user_id: isLoggedIn() ? userID : ''
            }
            dispatch(prorateList(proRate)).then((res) => {
                setWalletDisable(false)
                if (res?.data) {
                    setIsLoading(false)
                    setIsCouponApplied(true)
                    formData['permit_rate'] = res?.data?.base_rate
                    formData['discount_amount'] = res?.data?.promocode_discount_amount
                    formData['coupon_applied'] = true
                    formData['net_parking_amount'] = res?.data?.net_parking_amount
                    formData['surcharge_fee'] = res?.data?.surcharge_fee
                    formData['tax_fee'] = res?.data?.tax_fee
                    formData['additional_fee'] = res?.data?.additional_fee
                    formData['processing_fee'] = res?.data?.processing_fee
                    formData['proRateAPIData'] = res?.data
                    formData['permit_final_amount'] = res?.data?.permit_final_amount ? res?.data?.permit_final_amount : formData?.permit_final_amount
                    setFormData({ ...formData })
                    setProrateResponse(res?.data)
                    if (Number(res?.data?.total_amount) > 0) {
                        setTotalPrice(Number(res?.data?.total_amount))
                    } else {
                        setTotalPrice('0')
                    }
                    setCouponRemoveButton(true)
                    if (searchParams?.get('permitID')) {
                        handleCardShowInZeroAmount('0')
                    } else {
                        handleCardShowInZeroAmount(formData.permit_final_amount)
                    }
                } else {
                    setIsLoading(false)
                    setCouponError(res?.errors?.message)
                    setCouponRemoveButton(true)
                    const facility = JSON.parse(localStorage.getItem('facility'))
                    const permits = JSON.parse(localStorage.getItem('permits'))

                    const payLoadData = {
                        facility_id: facility?.id,
                        driving_license: formData?.license_number,
                        // permit_rate_id: permits?.id,
                        permit_rate_id: permits?.id ? permits?.id : formData?.permit_rate_id,
                        permit_service: formData?.permitService && formData?.permitService.length > 0 ? formData?.permitService : '',
                        desired_start_date: formData?.desired_start_date ? moment(formData?.desired_start_date).format('YYYY/MM/DD') : moment().format('YYYY/MM/DD'),
                        email: formData.email,
                        vehicleList: refractedVehicleList,
                        user_id: isLoggedIn() ? userID : ''

                    }
                    dispatch(prorateList(payLoadData)).then((res) => {
                        setIsCouponApplied(false)
                        if (searchParams?.get('permitID')) {
                            formData['is_guest'] = isLoggedIn() ? '0' : '1'
                            formData['permit_rate'] = '0'
                            formData['coupon_applied'] = false
                            formData['discount_amount'] = null
                            formData['net_parking_amount'] = '0'
                            formData['surcharge_fee'] = '0'
                            formData['tax_fee'] = '0'
                            formData['additional_fee'] = '0'
                            formData['processing_fee'] = '0'
                            formData['permit_final_amount'] = '0'
                            res.data.net_parking_amount = '0'
                            res.data.permit_final_amount = '0'
                            res.data.total_amount = '0'
                            res.data.permit_rate_prorate = '0'
                            res.data.effective_pro_rate = '0'
                            res.data.effective_days = '0'
                            res.data.base_rate = '0'
                            formData['proRateAPIData'] = res?.data
                        } else {
                            formData['is_guest'] = isLoggedIn() ? '0' : '1'
                            formData['permit_rate'] = res?.data?.base_rate
                            formData['coupon_applied'] = false
                            formData['discount_amount'] = null
                            formData['proRateAPIData'] = res?.data
                            formData['net_parking_amount'] = res?.data?.net_parking_amount
                            formData['surcharge_fee'] = res?.data?.surcharge_fee
                            formData['tax_fee'] = res?.data?.tax_fee
                            formData['additional_fee'] = res?.data?.additional_fee
                            formData['processing_fee'] = res?.data?.processing_fee
                            formData['permit_final_amount'] = res?.data?.permit_final_amount ? res?.data?.permit_final_amount : formData?.permit_final_amount
                        }
                        setFormData({ ...formData })
                        setProrateResponse(res?.data)
                        if (Number(res?.data?.total_amount) > 0 && !searchParams?.get('permitID')) {
                            setTotalPrice(Number(res?.data?.total_amount))
                        } else {
                            setTotalPrice('0')
                        }
                        setCouponRemoveButton(true)
                        if (searchParams?.get('permitID')) {
                            handleCardShowInZeroAmount('0')
                        } else {
                            handleCardShowInZeroAmount(formData.permit_final_amount)
                        }
                    })

                }

            }).catch((error) => {
                setWalletDisable(false)
                setCouponError(error?.errors?.message)
                setCoupon('')
                setCouponRemoveButton(false)
                const facility = JSON.parse(localStorage.getItem('facility'))
                const permits = JSON.parse(localStorage.getItem('permits'))

                const payLoadData = {
                    facility_id: facility?.id,
                    driving_license: formData?.license_number,
                    // permit_rate_id: permits?.id,
                    permit_rate_id: permits?.id ? permits?.id : formData?.permit_rate_id,
                    permit_service: formData?.permitService && formData?.permitService.length > 0 ? formData?.permitService : '',
                    desired_start_date: formData?.desired_start_date ? moment(formData?.desired_start_date).format('YYYY/MM/DD') : moment().format('YYYY/MM/DD'),
                    email: formData.email,
                    vehicleList: refractedVehicleList,
                    user_id: isLoggedIn() ? userID : ''

                }
                dispatch(prorateList(payLoadData)).then((res) => {
                    setIsCouponApplied(false)
                    if (searchParams?.get('permitID')) {
                        formData['is_guest'] = isLoggedIn() ? '0' : '1'
                        formData['net_parking_amount'] = '0'
                        formData['surcharge_fee'] = '0'
                        formData['tax_fee'] = '0'
                        formData['additional_fee'] = '0'
                        formData['processing_fee'] = '0'
                        formData['permit_rate'] = '0'
                        formData['coupon_applied'] = false
                        formData['discount_amount'] = null
                        formData['permit_final_amount'] = '0'
                        res.data.net_parking_amount = '0'
                        res.data.permit_final_amount = '0'
                        res.data.total_amount = '0'
                        res.data.permit_rate_prorate = '0'
                        res.data.effective_pro_rate = '0'
                        res.data.effective_days = '0'
                        res.data.base_rate = '0'
                        formData['proRateAPIData'] = res?.data
                    } else {
                        formData['is_guest'] = isLoggedIn() ? '0' : '1'
                        formData['net_parking_amount'] = res?.data?.net_parking_amount
                        formData['surcharge_fee'] = res?.data?.surcharge_fee
                        formData['tax_fee'] = res?.data?.tax_fee
                        formData['additional_fee'] = res?.data?.additional_fee
                        formData['processing_fee'] = res?.data?.processing_fee
                        formData['proRateAPIData'] = res?.data
                        formData['permit_rate'] = res?.data?.base_rate
                        formData['coupon_applied'] = false
                        formData['discount_amount'] = null
                        formData['permit_final_amount'] = res?.data?.permit_final_amount ? res?.data?.permit_final_amount : formData?.permit_final_amount
                    }
                    setFormData({ ...formData })
                    setProrateResponse(res?.data)
                    if (Number(res?.data?.total_amount) > 0 && !searchParams?.get('permitID')) {
                        setTotalPrice(Number(res?.data?.total_amount))
                    } else {
                        setTotalPrice('0')
                    }
                    if (searchParams?.get('permitID')) {
                        handleCardShowInZeroAmount('0')
                    } else {
                        handleCardShowInZeroAmount(formData.permit_final_amount)
                    }
                })
                setIsLoading(false)
                setIsCouponApplied(false)
                formData['coupon_applied'] = false

            })
        } else {
            setCouponError('Please enter a valid promocode')
            setCoupon('')
            setCouponRemoveButton(false)
            // const facility = JSON.parse(localStorage.getItem('facility'))
            // const permits = JSON.parse(localStorage.getItem('permits'))

            // const payLoadData = {
            //     facility_id: facility?.id,
            //     driving_license: formData?.license_number,
            //     // permit_rate_id: permits?.id,
            //     permit_rate_id: permits?.id ? permits?.id : formData?.permit_rate_id,
            //     permit_service: formData?.permitService && formData?.permitService.length > 0 ? formData?.permitService : '',
            //     desired_start_date: formData?.desired_start_date ? moment(formData?.desired_start_date).format('YYYY/MM/DD') : moment().format('YYYY/MM/DD'),
            //     email: formData.email,
            //     vehicleList: refractedVehicleList,
            //     user_id: isLoggedIn() ? userID : ''

            // }
            // dispatch(prorateList(payLoadData)).then((res) => {
            //     setIsCouponApplied(false)
            //     formData['is_guest'] = isLoggedIn() ? '0' : '1'
            //     formData['net_parking_amount'] = res?.data?.net_parking_amount
            //     formData['surcharge_fee'] = res?.data?.surcharge_fee
            //     formData['tax_fee'] = res?.data?.tax_fee
            //     formData['additional_fee'] = res?.data?.additional_fee
            //     formData['processing_fee'] = res?.data?.processing_fee
            //     formData['permit_rate'] = res?.data?.base_rate
            //     formData['coupon_applied'] = false
            //     formData['discount_amount'] = null
            //     formData['proRateAPIData'] = res?.data
            //     formData['permit_final_amount'] = res?.data?.permit_final_amount ? res?.data?.permit_final_amount : formData?.permit_final_amount
            //     setFormData({ ...formData })
            //     setProrateResponse(res?.data)
            //     if (Number(res?.data?.total_amount) > 0) {
            //         setTotalPrice(Number(res?.data?.total_amount))
            //     } else {
            //         setTotalPrice('0')
            //     }
            //     handleCardShowInZeroAmount(formData.permit_final_amount)
            // })
            setIsLoading(false)
            setIsCouponApplied(false)
            formData['coupon_applied'] = false

        }

    }

    const handleCardShowInZeroAmount = (finalAmount) => {
        if (finalAmount && Number(finalAmount) == 0 || cardList?.length > 0) {
            setCardFormVisible(false)
        } else {
            setCardFormVisible(true)
        }
    }

    const handleshowVehicle = () => {
        setDisplayVehicle(!displayVehicle)
    }

    const DisplayField = (label, value) => {
        return <div className="col-6">
            <label className="floatLabel">{label}</label>
            <div className="inputBox">{value || '-'}</div>
        </div>
    }

    const mobileViewVehicleSection = (vehicleListItem = {}, vehicleListIndex, allVehicle) => {
        return <div key={vehicleListIndex} className="row bg-light g-1 p-1 mt-3">
            {DisplayField('License Plate', vehicleListItem?.license_plate || '-')}
            {isPermissionExist(accessPermissions, 'Get Vehicle Type') && shouldShowVehicleColumn(allVehicle, 'vehicle_type') ? DisplayField('Vehicle Type', vehicleListItem?.vehicle_type || '-') : null}
            {shouldShowVehicleColumn(allVehicle, 'make') && shouldShowVehicleColumn(allVehicle, 'model') ? DisplayField('Make/Model', (vehicleListItem.make || vehicleListItem.model)
                ? `${vehicleListItem.make ?? ''}${allHaveMst_model && vehicleListItem.model ? ` / ${vehicleListItem.model}` : ''}`
                : '-' || '-') : null}
            {/* {is_modal_show ? DisplayField('Model', vehicleListItem?.model || '-') : null} */}
            {shouldShowVehicleColumn(allVehicle, 'color') ? DisplayField('Color', vehicleListItem?.color || '-') : null}
            {isPermissionExist(accessPermissions, 'Get Vehicle Style') && shouldShowVehicleColumn(allVehicle, 'style') ? DisplayField('Style', vehicleListItem?.style || '-') : null}

            {isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') && shouldShowVehicleColumn(allVehicle, 'country') ? DisplayField('Country', vehicleListItem?.country || '-') : null}
            {shouldShowVehicleColumn(allVehicle, 'state_code') ? DisplayField('State', vehicleListItem?.state_code || '-') : null}
            {isPermissionExist(accessPermissions, 'Vin Number') && shouldShowVehicleColumn(allVehicle, 'vehicle_number') ? DisplayField('VIN', vehicleListItem?.vehicle_number || '-') : null}
        </div>
    }

    const renderVehicleRow = (vehicle = {}, i, allVehicle) => {
        return (
            <tr key={i}>
                <td className="px-0">{vehicle.license_plate || '-'}</td>
                {isPermissionExist(accessPermissions, 'Get Vehicle Type') && shouldShowVehicleColumn(allVehicle, 'vehicle_type') && (
                    <td className="px-0">{vehicle.vehicle_type || '-'}</td>
                )}
                {shouldShowVehicleColumn(allVehicle, 'make') && shouldShowVehicleColumn(allVehicle, 'model') ? <td className="px-0">
                    {(vehicle.make || vehicle.model)
                        ? `${vehicle.make ?? ''}${allHaveMst_model && vehicle.model ? ` / ${vehicle.model}` : ''}`
                        : '-'}
                </td> : null}
                {shouldShowVehicleColumn(allVehicle, 'color') ? <td className="px-0">{vehicle.color || '-'}</td> : null}
                {isPermissionExist(accessPermissions, 'Get Vehicle Style') && shouldShowVehicleColumn(allVehicle, 'style') && (
                    <td className="px-0">{vehicle.style || '-'}</td>
                )}
                {isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') && shouldShowVehicleColumn(allVehicle, 'country') && (
                    <td className="px-0">{vehicle.country || '-'}</td>
                )}
                {shouldShowVehicleColumn(allVehicle, 'state_code') ? <td className="px-0">{vehicle.state_code || '-'}</td> : null}
                {isPermissionExist(accessPermissions, 'Vin Number') && shouldShowVehicleColumn(allVehicle, 'vehicle_number') && (
                    <td className="px-0">{vehicle.vehicle_number || '-'}</td>
                )}
            </tr>
        )
    }

    const deskTopViewVehicleSection = () => {
        return <div className='table-responsive'>
            <table className="table table-borderless table-sm mb-0">
                <thead>
                    <tr>
                        <th className="fw-bold text-muted px-0">License Plate</th>
                        {isPermissionExist(accessPermissions, 'Get Vehicle Type') && shouldShowVehicleColumn(refractedVehicleList, 'vehicle_type') && (
                            <th className="fw-bold text-muted px-0">Vehicle Type</th>
                        )}
                        {shouldShowVehicleColumn(refractedVehicleList, 'make') && shouldShowVehicleColumn(refractedVehicleList, 'model') ? <th className="fw-bold text-muted px-0">{`Make${allHaveMst_model ? ' / Model' : ''}`}</th> : null}
                        {shouldShowVehicleColumn(refractedVehicleList, 'color') ? <th className="fw-bold text-muted px-0">Color</th> : null}
                        {isPermissionExist(accessPermissions, 'Get Vehicle Style') && shouldShowVehicleColumn(refractedVehicleList, 'style') && (
                            <th className="fw-bold text-muted px-0">Style</th>
                        )}
                        {isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') && shouldShowVehicleColumn(refractedVehicleList, 'country') && (
                            <th className="fw-bold text-muted px-0">Country</th>
                        )}
                        {shouldShowVehicleColumn(refractedVehicleList, 'state_code') ? <th className="fw-bold text-muted px-0">State</th> : null}
                        {isPermissionExist(accessPermissions, 'Vin Number') && shouldShowVehicleColumn(refractedVehicleList, 'vehicle_number') && (
                            <th className="fw-bold text-muted px-0">VIN</th>
                        )}
                    </tr>
                </thead>

                <tbody>
                    {renderVehicleRow(refractedVehicleList?.[0], 0, refractedVehicleList)}
                </tbody>

                <tbody className="collapse" style={{ height: '300px' }} id='vehicleCollapse'>
                    {(refractedVehicleList?.slice(1) || []).map((v, i) => renderVehicleRow(v, i + 1, refractedVehicleList))}
                </tbody>
            </table>
        </div>
    }
    return (
        <div>
            <h4 className="mb-4  text-muted fw-semibold text-center">Confirm Your Details </h4>
            <div className="card ">
                <div className="row g-0">
                    <div className="col">
                        <div className="card-header fw-bold">
                            Basic Information
                        </div>
                        <div className="card-body">
                            <p className="mb-1"><small className='fw-bold text-muted'>Name :</small>  {formData?.firstname} {isPermissionExist(accessPermissions, 'Hide All Non Mandatory Fields') ? null : formData?.lastname} </p>
                            <p className="mb-1"><small className='fw-bold text-muted'>Email :</small>  {formData?.email}</p>
                            <p className="mb-0"><small className='fw-bold text-muted'>Phone Number :</small> {formData?.phone ? phoneMasker(formData?.phone) : 'N/A'}</p>
                        </div>
                    </div>
                    {!isPermissionExist(accessPermissions, 'Driving License') ? <div className="col-sm-6 border-start">
                        <div className="card-header">
                            <div className="d-flex">
                                <div className="fw-bold">Driver License Number : </div>
                                <p className="m-0 align-items-end ms-auto"><span className="badge badgeColor">{formData?.resident}</span> {formData?.license_number}</p>
                            </div>

                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col text-center ">
                                    <b>Drivers License Proof (Front)</b>
                                    {images?.front ? <div className="border  p-1 text-center">
                                        <img height="46px" src={images?.front} />
                                    </div> : <div className="p-1 text-center">-</div>}
                                </div>
                                <div className="col text-center ">
                                    <b>Drivers License Proof (Back)</b>
                                    {images?.back ? <div className="border  p-1 text-center">
                                        <img height="46px" src={images?.back} />
                                    </div> : <div className="p-1 text-center">-</div>}
                                </div>
                            </div>
                        </div>
                    </div> : null}
                </div>

                {employerDetailsSection(props?.employerDetails)}
                {/*  box one for basic inof */}

                {!formData?.is_hide_vehicle && (
                    <div className="border-top container py-2">
                        <div className="d-flex align-items-center mb-2 justify-content-between">
                            <b>Vehicle(s)</b>
                            {refractedVehicleList?.length > 1 && (
                                <div className='d-flex gap-2'>
                                    <span className='fw-bold text-primary'>
                                        {`${refractedVehicleList?.length} ${refractedVehicleList?.length > 1 ? 'Vehicles' : 'Vehicle'}`}
                                    </span>
                                    <button
                                        className='btn btn-outline-dark btn-sm'
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target='#vehicleCollapse'
                                        aria-expanded={displayVehicle}
                                        aria-controls='vehicleCollapse'
                                        onClick={handleshowVehicle}
                                    >
                                        {displayVehicle ? 'Hide All' : 'View All'}
                                    </button>
                                </div>
                            )}
                        </div>
                        {isMobile ? <div>
                            <div>
                                {mobileViewVehicleSection(refractedVehicleList?.[0], 0, refractedVehicleList)}
                            </div>

                            <div className="collapse" style={{ height: '300px' }} id='vehicleCollapse'>
                                {(refractedVehicleList?.slice(1) || []).map((v, i) => mobileViewVehicleSection(v, i + 1, refractedVehicleList))}
                            </div>
                        </div> : deskTopViewVehicleSection()}
                    </div>
                )}
            </div>

            {/*  first box ended */}

            {/*  second box started */}


            <div className="card  my-3">
                {/*  price section garage info started */}
                <div className='bg-light p-3'>
                    {/* PIMS-11105 */}
                    {(isPermissionExist(accessPermissions, 'Hide Facility') && !isDisplayFacility) ? null : <h4 className="text-primary fw-bold mb-1">{facility?.full_name}</h4>}
                    {/* {(isPermissionExist(accessPermissions, 'Hide Facility')) ? null : <h4 className="text-primary fw-bold mb-1">{facility?.full_name}</h4>} */}
                    <div className='row  justify-content-between g-2'>
                        <div className='col-sm col-12'>
                            {/* HIDING FACILITY DETAILS AND DISPLAYING PERMIT TIME VALIDATION TO SYNC DESIGN */}
                            {/* {(isPermissionExist(accessPermissions, 'Hide Facility') && !isDisplayFacility) ? formData?.selectedCategory?.is_hide_validity == '0' && selectedPermit?.permit_rate_criteria_mapping?.length > 0 ? perkingParkingTime(selectedPermit, false) : null : <p className="m-0 small"><b className='me-2'>Entrance Address:-</b> {`${facility?.geolocations?.address_1 ? facility?.geolocations?.address_1 : ''}${facility?.geolocations?.address_2 ? `, ${facility?.geolocations?.address_2}` : ''}${facility?.geolocations?.city ? `, ${facility?.geolocations?.city}` : ''}${facility?.geolocations?.state ? `, ${facility?.geolocations?.state}` : ''}${facility?.geolocations?.zip_code ? `, ${facility?.geolocations?.zip_code}` : ''}`}</p>} */}
                            {(isPermissionExist(accessPermissions, 'Hide Facility')) ? formData?.selectedCategory?.is_hide_validity == '0' && selectedPermit?.permit_rate_criteria_mapping?.length > 0 ? perkingParkingTime(selectedPermit, false) : null : <p className="m-0 small"><b className='me-2'>Entrance Address: </b>{`${facility?.geolocations?.address_1 ? facility?.geolocations?.address_1 : ''}${facility?.geolocations?.address_2 ? `, ${facility?.geolocations?.address_2}` : ''}${facility?.geolocations?.city ? `, ${facility?.geolocations?.city}` : ''}${facility?.geolocations?.state ? `, ${facility?.geolocations?.state}` : ''}${facility?.geolocations?.zip_code ? `, ${facility?.geolocations?.zip_code}` : ''}`}</p>}
                            {formData?.user_type_id ? <p className='small m-0'><b>Student/Staff/Faculty ID</b><span>
                                - {formData?.user_type_id}</span> </p> : ''}
                        </div>
                        {searchParams?.get('permitID') ? null : <div className='col-sm-auto col-12 text-sm-end '>
                            <div className='border-top  d-block d-sm-none'></div>
                            <p className='mb-0 small'>  <span className="me-2 fw-bold d-inine-block"> Start Date: - </span>   <span><i className='fa fa-calendar-alt small me-1'></i> {prorateResponse?.start_date ? `${moment(prorateResponse?.start_date, 'MM-DD-YYYY').format('MM/DD/YYYY')}` : ''}</span> </p>
                            <p className='mb-0 small' >  <span className="me-2 fw-bold d-inine-block"> End Date: - </span>    <span><i className='fa fa-calendar-alt small me-1'></i> {prorateResponse?.end_date ? `${moment(prorateResponse?.end_date, 'MM-DD-YYYY').format('MM/DD/YYYY')}` : ''}</span></p>

                        </div>}


                    </div>
                    {/* IN CASE IF WE ARE HIDING FACILITY, 
                    WE ARE MOVING THIS INFORMATION AT ABOVE DIV, 
                    HENCE HIDING IT FROM HERE ELSE PART WILL DISPLAY IT HERE AND HIDE FROM ABOVE*/}
                    {/* {(isPermissionExist(accessPermissions, 'Hide Facility') && !isDisplayFacility) ? null : <div className='border-top d-lock mt-2'> */}
                    {(isPermissionExist(accessPermissions, 'Hide Facility')) ? null : <div className='border-top d-lock mt-2'>
                        {selectedPermit?.permit_rate_criteria_mapping?.length > 0 ? perkingParkingTime(selectedPermit, false) : null}
                    </div>}
                </div>
                {/*  price section garage info ends */}

                {/*  price section breakup started */}
                <div className={`secondBlock ${searchParams?.get('permitID') ? 'd-none' : ''}`}>
                    <div className='d-flex px-3 py-2 align-items-center justify-content-between  bg-primary' >
                        <div className='text-white m-0 h5'>
                            Purchase Summary
                        </div>
                        <div className='text-white fw-bold m-0 h4'>




                            {/* {selectedPermit?.rate ? formData?.permitServicePrice ? `$${Number(Number(selectedPermit?.rate) + Number(formData?.permitServicePrice)).toFixed(2)}` : `$${selectedPermit?.rate}` : ''} */}
                            {isLoading ? <i className='fa fa-spinner fa-spin text-white'></i> : `$${prorateResponse?.permit_final_amount ? prorateResponse?.permit_final_amount : formatDecimal(0)}`}

                            <a className="btn ms-2 p-0 text-white border-0" data-bs-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
                                <i className='fa fa-info-circle'></i>
                            </a>



                        </div>

                    </div>

                </div>
                <div className={`collapse show ${searchParams?.get('permitID') ? 'd-none' : ''}`} id="collapseExample">
                    <div className="p-3">
                        {/* {rateList?.permit_rate?.map((permitPricesItem, permitPricesIndex) => {
                            return (
                                <> */}

                        <input type="radio" className='btn-check' name="permit_rate" id={'btnradio1'} autoComplete="off" onClick={(e) => handleInputFieldsData(e, 1, selectedPermit)} defaultChecked />
                        {/* checked={(permitPricesItem?.id === formData?.permit_rate_id)} */}


                        <b className='mainText'> Permit Type</b>
                        <div className='d-flex mb-3 px-0 border-bottom border-dashed mb-2 w-full align-items-center justify-content-between'>
                            <div>
                                <span className='text-muted me-2'>{selectedPermit?.name}</span>
                                <span className="timeValidationRes col-12 small text-primary">{formData?.selectedPermitType?.[0]?.is_hide_validity == '0' && formData?.selectedPermitType?.[0]?.description ? `(${formData?.selectedPermitType?.[0]?.description})` : ''}</span>
                            </div>
                            <div className='fw-semibold mainText'>
                                <span className='d-block text-end'>{prorateResponse?.effective_pro_rate ? `$${formatDecimal(Number(prorateResponse?.effective_pro_rate))}` : '-'}</span>
                                {(!facility?.facility_configuration || (facility?.facility_configuration && facility?.facility_configuration?.is_prorate_apply == '1' && Number(prorateResponse?.effective_pro_rate) > 0.01)) ? <span className='small text-muted fw-normal m-0 p-0'>{prorateResponse?.prorate_disable == '1' ? null : '(Prorated Price)'}</span> : null}
                            </div>
                        </div>


                        {formData?.permitService?.length > 0 ?
                            <div className='mb-2 border-bottom border-dashed pb-1'>
                                <b className='mainText'> Permit Services</b>
                                <div className='d-flex  px-0   w-full align-items-center justify-content-between'>

                                </div>
                                {formData?.permitService?.map((v, i) => {
                                    if (v?.permit_service_name != 'Select All Access') {
                                        return (

                                            <div key={i} className='d-flex  px-0   w-full align-items-center justify-content-between'>
                                                {/* <div className=' text-muted text-capitalize' >
                                                    {v?.permit_service_name}
                                                </div> */}
                                                <div>
                                                    <span className='text-muted text-capitalize me-2'>{v?.permit_service_name}</span>
                                                    <span className="timeValidationRes small text-primary">{(v?.permit_service_criteria_mappings && v?.permit_service_criteria_mappings?.length > 0) ? handlingPermitServiceCriteria(v?.permit_service_criteria_mappings) : null}</span>
                                                </div>
                                                <div className='fw-semibold '>
                                                    ${v?.permit_service_rate}
                                                </div>
                                            </div>
                                        )
                                    }

                                })
                                }

                            </div> : ''}

                        {/* {(!facility?.facility_configuration || (facility?.facility_configuration && facility?.facility_configuration?.is_prorate_apply != '0')) ?
                            <div className='d-flex mb-3 px-0 border-bottom border-dashed mb-2 w-full align-items-center justify-content-between'>
                                <div className='text-muted'>
                                    Prorated price
                                </div>
                                <div className='fw-semibold'>
                                    {prorateResponse?.effective_pro_rate ? `$${formatDecimal(Number(prorateResponse?.effective_pro_rate))}` : ''}
                                </div>
                            </div>
                            : null} */}
                        {formData.discount_amount ? <><b> Discount</b>
                            <div className='d-flex mb-3 px-0 border-bottom border-dashed mb-2 w-full align-items-center justify-content-between'>
                                <div className='text-muted'>
                                    Promocode Discount
                                </div>
                                <div className='fw-semibold'>
                                    {`(-) $${formatDecimal(Number(formData.discount_amount))}`}
                                </div>
                            </div></> : null}


                        {(() => {
                            const newParkingAmount = prorateResponse?.net_parking_amount

                            const numericNew = Number(newParkingAmount)

                            if (newParkingAmount) {
                                return (
                                    <div className='d-flex mb-3 px-0 border-bottom border-dashed mb-2 w-full align-items-center justify-content-between'>
                                        <div className='text-muted'>
                                            Net Permit Amount
                                        </div>
                                        <div className='fw-semibold'>
                                            {`$${formatDecimal(numericNew)}`}
                                        </div>
                                    </div>
                                )
                            }

                            return null
                        })()}

                        {/* {((prorateResponse?.processing_fee && Number(prorateResponse?.processing_fee) > 0) || (prorateResponse?.additional_fee && Number(prorateResponse?.additional_fee) > 0)) ?
                            <div className='d-flex mb-3 px-0 border-bottom border-dashed mb-2 w-full align-items-center justify-content-between'>
                                <div className='text-muted'>
                                    Processing Fee
                                </div>
                                <div className='fw-semibold'>
                                    <b>{(prorateResponse?.additional_fee && prorateResponse?.processing_fee) ? formatDecimal(Number(prorateResponse?.additional_fee) + Number(prorateResponse?.processing_fee)) : prorateResponse?.processing_fee ? formatDecimal(Number(prorateResponse?.processing_fee)) : formatDecimal(Number(prorateResponse?.processing_fee))}</b>
                                    <span className="text-muted d-block small">
                                        (Processing Fee: {formatDecimal(Number(prorateResponse?.processing_fee))})
                                    </span>
                                    

                                </div>
                            </div>
                            : null} */}
                        {(prorateResponse?.processing_fee || prorateResponse?.additional_fee) ?
                            <div className='d-flex mb-3 px-0 border-bottom border-dashed mb-2 w-full align-items-center justify-content-between'>
                                <div className='text-muted'>
                                    Processing Fee
                                </div>
                                <div className='fw-semibold'>
                                    <span className='d-block text-end'>
                                        ${(prorateResponse.additional_fee && prorateResponse.processing_fee) ? (Number(prorateResponse.additional_fee) + Number(prorateResponse.processing_fee)).toFixed(2) : prorateResponse.processing_fee ? Number(prorateResponse.processing_fee)?.toFixed(2) : Number(prorateResponse.processing_fee).toFixed(2)}
                                    </span>
                                    <span className='small text-muted fw-normal m-0 p-0'>
                                        (Processing Fee: {formatDecimal(Number(prorateResponse?.processing_fee))})
                                    </span>
                                </div>
                            </div>
                            : null}
                        {prorateResponse?.surcharge_fee ? <div className='d-flex mb-3 px-0 border-bottom border-dashed mb-2 w-full align-items-center justify-content-between'>
                            <div className='text-muted'>
                                City Surcharge
                            </div>
                            <div className='fw-semibold'>
                                {`$${formatDecimal(Number(prorateResponse?.surcharge_fee))}`}
                            </div>
                        </div> : null}
                        {prorateResponse?.is_keycard_applicable ? <>
                            <b className='mainText'> Key Card</b>
                            <div className='d-flex mb-3 px-0 border-bottom border-dashed mb-2 w-full align-items-center justify-content-between'>
                                <div>
                                    {/* <span className='d-block text-muted me-2'>{prorateResponse?.keycard?.name}</span> */}
                                    <span className="timeValidationRes col-12 small text-primary">{`(${errorMessage?.keyCardDisclaimerNote})`}</span>
                                </div>
                                <div className='fw-semibold mainText'>
                                    <span className='d-block text-end'>{(prorateResponse?.keycard && prorateResponse?.keycard?.price) ? `$${formatDecimal(Number(prorateResponse?.keycard?.price))}` : '-'}</span>
                                </div>
                            </div>
                        </> : null}

                        {prorateResponse?.tax_fee ? <div className='d-flex mb-3 px-0 border-bottom border-dashed mb-2 w-full align-items-center justify-content-between'>
                            <div className='text-muted'>
                                Tax Fee
                            </div>
                            <div className='fw-semibold'>
                                {`$${formatDecimal(Number(prorateResponse?.tax_fee))}`}
                            </div>
                        </div> : null}

                        {prorateResponse?.processing_fee && Number(prorateResponse?.processing_fee) > 0 ?
                            <div className='d-flex mb-3 px-0 border-bottom border-dashed mb-2 w-full align-items-center justify-content-between'>
                                <div className='fw-bold'>
                                    Total Price
                                </div>
                                <div className='fw-bold'>
                                    {isLoading ? <i className='fa fa-spinner fa-spin text-primary'></i> : `$${prorateResponse?.permit_final_amount ? prorateResponse?.permit_final_amount : formatDecimal(0)}`}
                                </div>
                            </div>
                            : null}
                        {/* <div className='mb-2'>
                            <b>Coupon Type</b>

                            <div className='d-flex px-0 border-bottom border-dashed mb-2 w-full align-items-center justify-content-between'>
                                <div className='text-muted small'>
                                    {selectedPermit?.name}
                                </div>
                                <div className='fw-semibold'>
                                    ${formData.permit_rate}
                                </div>
                            </div>
                        </div> */}

                        {/* <span>{permitPricesIndex + 1}</span> */}
                        {/* </>
                            )
                        })} */}
                    </div>
                </div>
            </div>
            <div className="border mb-3">

                {/* {dynamic permit} */}


                {(isPermissionExist(accessPermissions, 'Display Promocode') && (prorateResponse?.permit_final_amount && Number(prorateResponse?.permit_final_amount) > 0) || (formData?.coupon_applied && prorateResponse?.permit_final_amount && Number(prorateResponse?.permit_final_amount) == 0)) ? <div className="block p-3 border-bottom">
                    <div className="row">
                        <div className="col-sm-6">

                            <label htmlFor="promocode" className="form-label">Promo Code</label>

                            <div className="input-group position-relative">
                                <input
                                    autoComplete="off"
                                    className="form-control "
                                    placeholder="Enter Promo Code"
                                    name="promocode"
                                    value={coupon ? coupon : formData?.promocode ? formData?.promocode : ''}
                                    onChange={handleInputFieldsData}
                                    type="text"
                                    required=""
                                    disabled={couponRemoveButton}
                                />
                                <button type="button" className="btn btn-primary d-flex align-items-center" disabled={isCouponApplied} onClick={(e) => handleCouponCode(e)}>Apply  {isLoading ?
                                    <span className='ms-1'><Circles
                                        height="15"
                                        width="15"
                                        color="#ffffff"
                                        ariaLabel="circles-loading"
                                        visible={true}
                                    /></span> : null}
                                </button>
                                {couponRemoveButton && <span className="btn floatBtnCross" id="basic-addon1" onClick={handleCouponRemove}><i className='fa fa-times text-danger'></i></span>}
                            </div>
                            {formData?.coupon_applied ? <span className='text-success'>Promocode Applied</span> : null}
                        </div>


                        {couponError ? <div className='errorBlock d-inline-block'>{couponError == 'loading' ? <span className=' ms-2'><Circles
                            height="20"
                            width="20"
                            color="var(--bs-primary)"
                            ariaLabel="circles-loading"
                            visible={true}
                        /></span> : <small className='text-danger'>{couponError}</small>}
                        </div> : ''}



                    </div>

                </div> : null}
                {/* Hide the Section to combine Prorate and Normal Summary in single Grid */}
                {(!facility?.facility_configuration || (facility?.facility_configuration && facility?.facility_configuration?.is_prorate_apply != '0')) ? <div className="card d-none">
                    <div className="card-header">
                        <b> Purchase Summary</b>
                    </div>
                    {paymentLoader && coupon ? <span className='m-5 d-flex justify-content-center'><Circles
                        height="40"
                        width="40"
                        color="var(--bs-primary)"
                        ariaLabel="circles-loading"
                        visible={true}
                    /></span> : <div className="card-body">
                        <div className="row align-items-center g-5">
                            <div className="col-12 col-sm-6">
                                <table className="table table-sm table-borderless">
                                    <tbody><tr>
                                        <th>
                                            Price
                                        </th>
                                        <td>:</td>
                                        <td className='text-end'>
                                            <span>{prorateResponse?.effective_pro_rate ? `$${prorateResponse?.effective_pro_rate} (Prorated price)` : ''}</span>
                                        </td>
                                    </tr>
                                        {(prorateResponse?.processing_fee && prorateResponse?.processing_fee > 0) && <tr>
                                            <th>
                                                Processing Fee
                                            </th>
                                            <td>:</td>
                                            <td className='text-end'>
                                                <span>{(prorateResponse?.processing_fee && prorateResponse?.processing_fee > 0) ? `+ $${prorateResponse?.processing_fee}` : ''}</span>
                                            </td>
                                        </tr>}
                                        <tr>
                                            <th>
                                                Start Date
                                            </th>
                                            <td>:</td>
                                            <td className='text-end'>
                                                <span>{prorateResponse?.start_date ? `${moment(prorateResponse?.start_date, 'MM-DD-YYYY').format('MM/DD/YYYY')}` : ''}</span>
                                            </td>
                                        </tr><tr>
                                            <th>
                                                End Date
                                            </th>
                                            <td>:</td>
                                            <td className='text-end'>
                                                <span>{prorateResponse?.end_date ? `${moment(prorateResponse?.end_date, 'MM-DD-YYYY').format('MM/DD/YYYY')}` : ''}</span>
                                            </td>
                                        </tr>
                                        {(isCouponApplied && prorateResponse?.promocode_discount_amount) ?
                                            <tr>
                                                <th>
                                                    Promo Code Discount
                                                </th>
                                                <td>:</td>
                                                <td className='text-end'>
                                                    <span className="text-danger">{prorateResponse?.promocode_discount_amount ? `- $${prorateResponse?.promocode_discount_amount}` : ''}</span>
                                                </td>
                                            </tr> : ''}


                                    </tbody></table>


                            </div>

                            <div className="col text-end">

                                <h3 className="fw-bold m-0">Total : {prorateResponse?.total_amount ? `$${prorateResponse?.total_amount}` : ''}</h3>

                                {/* <h3 className="fw-bold m-0">Total : {prorateResponse?.total_amount ? `$${prorateResponse?.total_amount}` : ''}</h3> */}
                            </div>
                        </div>
                    </div>}
                </div> : ''}
                {/* Hide the Section to combine Prorate and Normal Summary in single Grid */}

                {(prorateResponse?.total_amount && Number(prorateResponse?.total_amount) > 0 && (verifyPrepay == '0' || !walletButtonShow)) && <div className={prorateResponse?.total_amount ? Number(prorateResponse?.total_amount) > 0 ? 'd-inline' : Number(formData?.permitServicePrice) > 0 ? 'd-inline' : 'd-none' : 'd-none'}>
                    <div className="mt-4 px-3" id="accountExpand">
                        <b className="mt-0" style={{ fontSize: 'larger' }}>Payment Details</b>
                        <hr className="my-1" />
                        {isLoggedIn() && <div className='row '>
                            {cardList?.length > 0 && <div className="col-sm-6">
                                <div className="mb-3">
                                    <select name="card_id" id="card_id" disabled={isCardFormVisible} className="form-select" onChange={handleCardSelectChange} >
                                        <option value=''>Select Card</option>
                                        {cardList?.map((card, index) => {
                                            return (
                                                <option value={card?.payment_profile_id} selected={card?.payment_profile_id == formData?.payment_profile_id} key={index}>{`XXXX XXXX XXXX ${card?.card_last_four?.slice(0, 4) ? card?.card_last_four?.slice(0, 4) : 'XXXX'} (${card?.expiry?.slice(0, 2) ? card?.expiry?.slice(0, 2) : '-'}/${card?.expiry?.slice(2, 4) ? card?.expiry?.slice(2, 4) : '-'})`}</option>
                                            )
                                        })}
                                    </select>
                                    <span className="form-text text-danger h-40">{formError == 'pass' && !isCardFormVisible && (!formData?.payment_profile_id && !formData?.card_pan) ? 'Please select or add new card' : ''}</span>
                                </div>
                            </div>}

                            {/* {cardList?.length > 0 && !isCardFormVisible ? <div className='col-sm-6 mb-3'>{cardList?.length > 0 && <span className='badge badge-primary text-dark fw-bold me-2'>OR</span>}<button className='btn btn-primary' type="button" onClick={showCardForm}><i className='fa fa-plus'></i> Add New Card</button></div> : cardList?.length > 0 && <div className='col-sm-6 mb-3'><span className='badge badge-primary text-dark fw-bold me-2'>OR</span>  <button className='btn btn-danger' type="button" onClick={hideCardForm}>Select Existing Card</button></div>} */}

                            {cardList?.length > 0 && !isCardFormVisible ?
                                <div className='col-sm-6 mb-3'>
                                    {cardList?.length > 0 &&
                                        <span className='badge badge-primary text-dark fw-bold me-2'>OR</span>}

                                    <button className='btn btn-primary' type="button" onClick={showCardForm}><i className='fa fa-plus'></i> Add New Card</button>
                                </div> : cardList?.length > 0 &&
                                <div className='col-sm-6 mb-3'><span className='badge badge-primary text-dark fw-bold me-2'>OR</span>
                                    <button className='btn btn-danger' type="button" onClick={hideCardForm}>Select Existing Card</button></div>}

                        </div>}

                        {(isCardFormVisible) && formData?.selFaclity?.facility_payment_details?.facility_payment_type_id != '3' ?
                            <div>
                                {/* Name & Card */}
                                <div className="row">
                                    <div className="col-sm-6 ">
                                        <div className="mb-3">
                                            <label htmlFor="Name on Card" className="form-label">Name on Card <span className='text-danger'> *</span></label>
                                            <input
                                                onChange={handleInputFieldsData}
                                                autoComplete="off"
                                                name='name'
                                                id='name'
                                                className="form-control "
                                                maxLength={20}
                                                minLength={1}
                                                placeholder="Name on Card"
                                                type="text"
                                                onKeyPress={(e) => handleKeyPressRestrictLeadingTrailingSpace(e)}
                                                required="" />
                                            {/* <span className="form-text text-danger h-40">{formError == 'pass' && !formData?.name ? 'This field is required' : ''}</span> */}
                                            {requiredTextInput(validator.current, 'name', formData?.name, 'Name', 'required')}
                                        </div>
                                    </div>

                                    <div className="col-sm-6 col-md-6">
                                        <div className="mb-3">
                                            <label htmlFor="Card Number" className="form-label">Card Number <span className='text-danger'> *</span>
                                            </label>
                                            <MaskedInput
                                                maskGenerator={cardnumbermask}
                                                value={card}
                                                type="text"
                                                name="card_pan"
                                                id="card_pan"
                                                required={true}
                                                pattern="[0-9 ]{18,19}"
                                                maxLength='19'
                                                minLength='18'
                                                title="Card no. should be 15-16 digit numeric"
                                                className="form-control"
                                                onChange={handleCardChange}
                                                placeholder="Card Number"
                                            />
                                            {/* <span className="form-text text-danger h-40">{formError == 'pass' ? !formData?.card_pan ? 'This field is required' : validateCardNumber(formData?.card_pan) ? '' : '' : ''}</span> */}
                                            {requiredTextInput(validator.current, 'card_pan', formData?.card_pan, 'Card Number', 'required')}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-6 col-md-6">
                                        <div className="mb-3">
                                            <label htmlFor="Card Number" className="form-label">Card Expiry <span className='text-danger'> *</span>
                                            </label>
                                            <MaskedInput
                                                maskGenerator={expirymask}
                                                value={expiry}
                                                type="text"
                                                autoComplete="off"
                                                name="expiration_date"
                                                id="expiration_date"
                                                required={true}
                                                pattern="[0-9 ]{4}"
                                                maxLength='5'
                                                minLength='4'
                                                title="Enter a valid expiry date"
                                                className="form-control"
                                                onChange={handleExpiryChange}
                                                onInvalid={e => e.target.setCustomValidity('Please enter a valid expiry date')}
                                                onInput={e => e.target.setCustomValidity('')}
                                                placeholder="MM/YY"
                                            />

                                            {/* <span className="form-text text-danger h-40">{formError == 'pass' ? !formData?.expiration_date ? 'This field is required' : '' : ''}</span> */}
                                            {requiredTextInput(validator.current, 'expiration_date', formData?.expiration_date, 'Card Expiry')}
                                            {/* <span className="form-text text-danger h-40">{formError == 'pass' ? formData?.expiration_date && (formData?.expiration_date?.length<4 || formData?.expiration_date?.length>5)? 'Enter a valid expiry date ':'' : ''}</span> */}
                                            <span className='form-text text-danger h-40'>{cardExpiryMessage}</span>

                                        </div>
                                    </div>

                                    {/* <div className="col-sm-4 col-6 mb-3">
                                    <label htmlFor="Expiry Month" className="form-label">Expiry Month <span className='text-danger'> *</span></label>
                                    <select
                                        name='card_date_expiry_month'
                                        id="card_date_expiry_month"
                                        required=""
                                        className="form-select"
                                        onChange={handleInputFieldsData}
                                        value={formData?.card_date_expiry_month}
                                    >
                                        <option value="">Expiry Month</option>
                                        {EXPIRY_MONTHS.map((item, key) => <option key={key} value={item}>{item}</option>)}
                                    </select>
                                    <span className="form-text text-danger h-40">{formError == 'pass' && !formData?.card_date_expiry_month ? 'This field is required' : ''}</span>
                                </div>

                                <div className="col-sm-4 col-6 mb-3">
                                    <label htmlFor="Expiry Year" className="form-label">Expiry Year<span className='text-danger'> *</span></label>

                                    <select
                                        name='card_date_expiry_year'
                                        id='expiryYear'
                                        required=""
                                        className="form-select"
                                        onChange={handleInputFieldsData}
                                        value={formData?.card_date_expiry_year}
                                    >
                                        <option value="">Expiry Year</option>
                                        {EXPIRY_YEARS.map((item, key) => <option key={key} value={item.val}>{item.label}</option>)}
                                    </select>
                                    <span className="form-text text-danger h-40">{formError == 'pass' && !formData?.card_date_expiry_year ? 'This field is required' : ''}</span>

                                </div> */}

                                    <div className="col-sm-6 col-md-6">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label">CVV <span className='text-danger'> *</span></label>
                                            <input
                                                onChange={handleInputFieldsData}
                                                autoComplete="off"
                                                className="form-control"
                                                id="standardCardCvv"
                                                maxLength="4"
                                                name="card_card_security_cvx_2"
                                                placeholder="CVV / Security Code"
                                                type="password"
                                                onKeyPress={(e) => restrictInputValues(e)}

                                                required=""
                                            />
                                            {/* <span className="form-text text-danger h-40">{formError == 'pass' && !formData?.card_card_security_cvx_2 ? 'This field is required' : ''}</span> */}
                                            {requiredTextInput(validator.current, 'card_card_security_cvx_2', formData?.card_card_security_cvx_2, 'CVV', 'required')}
                                        </div>
                                    </div></div>
                                <div className="row">

                                    <div className="col-sm-6">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label">Zip Code</label>
                                            <input
                                                onChange={handleInputFieldsData}
                                                className="form-control "
                                                maxLength="6"
                                                minLength="5"
                                                name="zip_code"
                                                pattern="[0-9]{5,6}"
                                                placeholder="Billing Address Zip Code"
                                                onPaste={(e) => {
                                                    e.preventDefault()
                                                    return false
                                                }}
                                                onKeyPress={(e) => isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ? restrictSpecialChar(e) : restrictInputValues(e)}
                                                type="text"
                                            />
                                            <span className="form-text text-danger h-40">**Mandatory for Amex Cards only</span>
                                            {/* <span className="form-text text-danger h-40">{formError == 'pass' && !formData?.zip_code ? 'This field is required' : ''}</span> */}
                                        </div>
                                    </div>
                                </div>


                                <input type='hidden' name='XXX_IPG_XXX' id='XXX_IPG_XXX' value='confirm' />
                                <input type='hidden' name='XXX_IPGTRXNO_XXX' id='XXX_IPGTRXNO_XXX' value={guidValue} />
                                <input type='hidden' name='XXX_IPGSESSION_XXX' id='XXX_IPGSESSION_XXX' value={resValue}></input>
                            </div> :
                            (!isLoggedIn() || isCardFormVisible) ? <CardConnectTokenizer
                                setToken={setCardToken}
                                faciltyPaymentDetails={formData?.selFaclity?.facility_payment_details}
                                setIframeErrorMessage={setIframeErrorMsg}
                                tokenRef={tokenRef}
                            /> : null
                        }
                    </div>
                </div>}

                {(verifyPrepay == '0' || !walletButtonShow) && <div className=' my-2 px-3' >
                    {!hideAutoRenewConsent ? (
                        <div className='alert alert-warning py-1 px-2 mb-2 rounded-3'>
                            <div className="form-check ">
                                <input disabled={(isCouponApplied && Number(formData?.permit_final_amount) <= 0) || prorateResponse?.hide_auto_consent == '1' ? true : false} className="form-check-input" type="checkbox" id="userConsent" name="userConsent" onClick={(e) => handleConsentChange(e)} checked={isConsent} />                        {/* defaultChecked={isConsent} */}
                                {/* <small>By clicking this button, you are providing your <b>consent for auto renewal of the permit</b> {formData?.isPermitPurchase == '0' ? 'if approved.' : formData?.isPermitPurchase == '1' ? '.' : ''}</small> */}
                                <small>By clicking this button, you agree to the automatic monthly renewal of your permit. If you intend to use a promo code each month, please do not check this box.</small>
                            </div>
                        </div>
                    ) : null}
                    <TCAcceptanceSection
                        accessPermissions={accessPermissions}
                        formData={formData}
                        setFormData={setFormData}
                        formError={formError == 'pass'}
                        partnerDetails={partnerDetails}
                        validator={validator}
                        showTerm={showTerm}
                        setShowTerm={setTermShow}
                        handleInputFieldsData={handleInputFieldsData}
                    />
                    {!hideAutoRenewConsent && prorateResponse?.hide_auto_consent == '1' ? <div className=' my-2 px-3' >
                        <div className='alert alert-danger py-1 px-2 mb-2 rounded-3'>
                            <div className="form-check ">
                                <small>{prorateResponse?.hide_auto_consent_msg || ''}</small>
                            </div></div></div> : null}
                    {prorateResponse?.error_permit_exist && prorateResponse?.error_permit_exist != '' ? <div className=' my-2 px-3' >
                        <div className='alert alert-danger py-1 px-2 mb-2 rounded-3'>
                            <div className="form-check ">
                                <small>{prorateResponse?.error_permit_exist != '' ? prorateResponse?.error_permit_exist : ''}</small>
                            </div></div></div> : null}
                </div>}
            </div>
        </div>
    )
}

Pass.propTypes = {
    dispatch: PropTypes.func,
    data: PropTypes.object,
    events: PropTypes.object,
    loader: PropTypes.bool,
    getCard: PropTypes.func,
    passData: EMPTY_ARRAY,
    setPage: PropTypes.string,
    idProof: PropTypes.object,
    rateList: PropTypes.object,
    paymentLoader: PropTypes.bool,
    formData: PropTypes.object,
    setFormData: PropTypes.func,
    formError: PropTypes.string,
    guidValue: PropTypes.string,
    resValue: PropTypes.string,
    partnerDetails: PropTypes.object,
    notify: PropTypes.func,
    selectedVehicleList: PropTypes.array,
    setTotalPrice: PropTypes.func,
    verifyPrepay: PropTypes.string,
    walletButtonShow: PropTypes.bool,
    setWalletDisable: PropTypes.func,
    employerDetails: PropTypes.object,
    validator: PropTypes.object,
    isCardFormVisible: PropTypes.bool,
    setCardFormVisible: PropTypes.func,
    tokenRef: PropTypes.object,
    setCardToken: PropTypes.func,
    setIframeErrorMsg: PropTypes.func,
}

Pass.defaulProps = {
    dispatch: noop,
    data: EMPTY_OBJECT,
    events: EMPTY_OBJECT,
    loader: PropTypes.bool,
    getCard: PropTypes.func,
    passData: EMPTY_ARRAY,
    setPage: undefined,
    idProof: EMPTY_OBJECT,
    rateList: EMPTY_OBJECT,
    paymentLoader: false,
    formData: EMPTY_OBJECT,
    setFormData: noop,
    formError: undefined,
    guidValue: '',
    resValue: '',
    partnerDetails: EMPTY_OBJECT,
    notify: noop,
    selectedVehicleList: EMPTY_ARRAY,
    setTotalPrice: noop,
    verifyPrepay: '',
    walletButtonShow: false,
    setWalletDisable: noop,
    tokenRef: EMPTY_OBJECT,
    setCardToken: noop,
    setIframeErrorMsg: noop,
}

function mapStateToProps({ paymentReducer, basicInfoReducer, PartnerReducer }) {
    return {
        data: paymentReducer,
        paymentLoader: paymentReducer?.proRateLoader,
        rateList: basicInfoReducer.rateList.data,
        partnerDetails: PartnerReducer?.partnerDetails?.data,
    }
}
export default connect(mapStateToProps)(Pass)